import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 220577A0-1D92-46EA-8116-DF964F6C57F0
 * name syllabary-katakana
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-katakana.svg
 * tags
 * - Alpha / Numeric 
 */
export const SyllabaryKatakanaIcon = createSvgIcon(<><path d="M4 4V6H18V6.09L14.29 9.79L15.71 11.21L20 6.91V4M11 9V13C11 15.78 10.25 16.89 8.36 18.46L9.64 20C11.75 18.24 13 16.22 13 13V9Z" /></>, 'SyllabaryKatakanaIcon');
export default SyllabaryKatakanaIcon